<template>
    <div class="row justify-content-center">
        <div class="col-12">
            <!-- Card -->
            <div class="card card-inactive" v-if="!isDataLoading && invoices.length==0">
                <div class="card-body text-center text-muted small">
                    <div class="row justify-content-center">
                        <div class="col-12 col-md-10 col-xl-8">
                            <!-- Image -->
                            <img
                                src="@/assets/img/illustrations/scale.svg"
                                alt="..."
                                class="img-fluid mt-n5 mb-4"
                                style="max-width: 272px;"
                            />
                            <h2>{{$t('Payments')}}</h2>
                            <p class="text-muted">{{$t('No payments yet')}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" data-toggle="lists" v-else>
                <div class="card-header">
                    <div class="row align-items-center">
                        <div class="col"></div>
                        <!-- <div class="col-auto">
                            <div class="dropdown">Filter by status</div>
                        </div>
                        <div class="col-auto">
                            <div class="dropdown">Filter by Resources</div>
                        </div>-->
                        <div class="col-auto">
                            <div class="dropdown">
                                <b-button-group>
                                    <button class="btn btn-white" v-if="paymentMethod.length" @click="paymentMethod=[]">
                                        <span class="fe fe-x"></span>
                                    </button>
                                    <b-dropdown variant="white" right :text="$t('Payment methods')">
                                        <div class="p-2">
                                            <b-form-checkbox
                                                v-model="paymentMethod"
                                                v-for="(paymentM, index) in paymentMethods"
                                                :value="paymentM.value"
                                                :key="index"
                                                class="mb-3"
                                            >{{ $t(paymentM.text)}}</b-form-checkbox>
                                        </div>
                                    </b-dropdown>
                                </b-button-group>
                            </div>
                        </div>
                        <div class="col-auto">
                            <date-filter v-model="dateFilter"></date-filter>
                        </div>
                    </div>
                    <!-- / .row -->
                </div>

                <div class="card-body" v-if="isDataLoading">
                    <div class="row align-items-center active">
                        <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                <div class="card-body" v-else>
                    <ul class="list-group list-group-lg list-group-flush list my-n4">
                        <li
                            class="list-group-item px-0 pointer"
                            v-for="(invoice, index) in invoices"
                            :key="index"
                            @click="openModal({id:'InvoiceModal', model:{invoiceId:invoice._id}})"
                        >
                            <div class="row align-items-top">
                                <div class="text-muted small col-auto">
                                    <status-badge :status="invoice.status || 'new'"></status-badge>
                                </div>

                                <div class="col">
                                    <div class="h3 mb-0">{{ invoice.createdAt | moment('MMMM Do') }}</div>
                                    <span class="small text-muted">{{ invoice.createdAt | moment('dddd, YYYY h:mm a') }}</span>
                                </div>
                                <div
                                    class="col-auto"
                                    v-if="invoice.paymentMethod"
                                >{{$t(paymentMethodLabel(invoice.paymentMethod).label)}}</div>
                                <div class="col-2 small text-muted">
                                    <money :value="invoice.pricing.products" v-if="invoice.pricing" />
                                    <br />
                                    <money :value="invoice.pricing.services" v-if="invoice.pricing" />
                                </div>
                                <div class="col-auto h3">
                                    <money :value="invoice.totalPrice" />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- <invoice-modal id="InvoiceModal" :data="model"></invoice-modal> -->
    </div>
</template>

<script>

import debounce from 'lodash/debounce';
import Money from '@/components/Money.vue';
import InvoiceModal from '@/Pages/Sales/InvoiceModal.vue';
import { modalMixins } from '@/mixins/modal.js'
import DateFilter from '@/components/DateFilter.vue';
import StatusBadge from '@/components/StatusBadge.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import paymentMethod from '@/filters/payment.js';

export default {
    mixins: [modalMixins],
    components: {
        Money,
        DateFilter,
        StatusBadge,
        InvoiceModal,
    },
    computed: {
        ...mapState('invoices', { isDataLoading: 'isFindPending' }),
        ...mapGetters('invoices', { findDataInStore: 'find' }),


        invoices() {
            return this.findDataInStore(this.params).data;
        },
        byDateLabel() {
            if (this.date_range == 'custom') {
                return this.date;
            } else
                return this.labels[this.date_range];
        },


    },
    data() {
        return {
            modalName: 'customerFormModal',
            model: {},
            dateFilter: null,
            paymentMethod: [],
            paymentMethods: [
                { text: 'Cash', value: 'cash' },
                { text: 'Bank', value: 'bank' },
                { text: 'Card', value: 'card' },
                { text: 'Other', value: 'other' },
                { text: 'Credit', value: 'credit' },
            ],

            params: {
                query: {
                    $limit: 1000,
                    customerId: this.$route.params.id,
                    $sort: {
                        createdAt: -1
                    }
                }
            }
        };
    },
    created() {
        this.fetchInvoices();
    },
    watch: {

        paymentMethod: debounce(function (method) {
            if (method.length > 0) {
                this.params.query.paymentMethod = { $in: method };
            } else {
                delete this.params.query.paymentMethod;
            }
            this.fetchInvoices();
        }, 100),
        dateFilter: debounce(function (dates) {

            if (dates.start) {
                this.params.query.createdAt = {
                    $gte: dates.start,
                    $lte: dates.end
                }
            } else {
                delete this.params.query.createdAt;
            }
            this.fetchInvoices();
        }, 100),

    },
    methods: {
        ...mapActions('invoices', ['find']),
        fetchInvoices() {
            this.find(this.params);
        },
        paymentMethodLabel(method) {

            return paymentMethod(method);

        }
    }
}
</script>
